
import { createAction, createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

import type { Company } from './../lib/types';
import { companyApi } from './../lib/api';
import type { AppState } from './redux';

export const FETCH_COMPANY = 'vehicles/company/fetch';
export const UPDATE_COMPANY = 'vehicles/company/update';
export const CLEAN_COMPANY = 'vehicles/company/clean';

export type CompanyState = Company | null;

const initialState: CompanyState = null;

const fetchCompanyAction = createAction<Company>(FETCH_COMPANY);
const updateCompanyAction = createAction<Company>(UPDATE_COMPANY);
const cleanCompanyAction = createAction(CLEAN_COMPANY);

const companySlice = createSlice({
  name: 'company',
  initialState: initialState as CompanyState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCompanyAction, (state, { payload }) => ({ ...payload }))
      .addCase(updateCompanyAction, (state, { payload }) => ({ ...payload }))
      .addCase(cleanCompanyAction, () => null);
  }
});

export const companyActions = {
  fetch: fetchCompanyAction,
  update: updateCompanyAction,
  clean: cleanCompanyAction
};

export const addCompany = (company: Company) => async (
  dispatch: Dispatch
): Promise<void> => {
  await companyApi.addCompany(company);
};

export const updateCompany = (company: Company) => async (
  dispatch: Dispatch
): Promise<void> => {
  const updated = await companyApi.updateCompany(company);
  dispatch(companyActions.update({ ...updated }));
};

export const fetchCompany = (id: number) => async (dispatch: Dispatch) => {
  const company = await companyApi.fetchCompany(id);
  dispatch(companyActions.fetch({ ...company }));
};

export const cleanCompany = () => (dispatch: Dispatch) =>
  dispatch(companyActions.clean());

export default companySlice.reducer;
